module.exports = __webpack_public_path__ + "static/media/sat-6.daa23a30.pdf";